export const iconFontAwesomeWeatherTemperatureFull = (
	<i className="fa-solid fa-temperature-full"></i>
);
